import useSWR from 'swr';
import { CommunityShotItem } from 'types/community';
import styles from './ShotMetadata.module.css';
import { jsonFetcherWithHandler as fetcher } from 'lib/swr';
import { commentsHandler } from 'lib/comments';
import { VoidCallback } from 'types/callbacks';

type Props = {
  shotItem: CommunityShotItem;
  onClick: VoidCallback;
};

export default function CommentsButton({ shotItem, onClick }: Props) {
  const { data: commentItems } = useSWR(
    `/api/community-posts/${shotItem.communityPostId}/comments`,
    fetcher(commentsHandler)
  );

  if (commentItems && commentItems.length > 0) {
    return (
      <button className={styles.Action} onClick={onClick}>
        Comments{' '}
        <div className={styles.CommentActionCount}>{commentItems.length}</div>
      </button>
    );
  }
  return <button className={styles.Action}>Comments</button>;
}
